interface CacheRecordItem<T> {
    time: number;
    value: T;
}

export default class CacheRecord<T> {

    private cache: Record<string, CacheRecordItem<T>>;
    private ttl: number;

    constructor(ttl: number) {
        this.ttl = ttl;
        this.cache = {};
    }

    setValue(key: string, value: T) {
        const time = Date.now();
        this.cache[key] = { time, value };
    }

    getValue(key: string): T | null {
        if (key in this.cache) {
            const now = Date.now();
            const result = this.cache[key];
            const { time, value } = result;
            if (time > now - this.ttl) return value;
        }

        return null;
    }

}